import moment from "moment";
import { useEffect } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"

export default function CounsellingEnquiryView() {
  const location = useLocation()
  const { enquiry } = location.state;
  const navigate = useNavigate()

  const statusClass = (requestAccepted) => {
    switch (requestAccepted) {
      case true:
        return 'bg-green-200 text-green-800 border-green-400'
      case undefined:
        return 'bg-orange-200 text-orange-800 border-orange-400 '
      case false:
        return 'bg-rose-200 text-rose-800 border-rose-400'
      default:
        return 'bg-gray-200 text-gray-800'
    }
  }

  const statusText = (requestAccepted) => {
    switch (requestAccepted) {
      case true:
        return 'Accepted'
      case undefined:
        return 'Awaiting Review'
      case false:
        return rejectionText(enquiry?.task_info?.counselling_info?.rejection_reason);
      default:
        return 'N/A'
    }
  }

  const rejectionText = (rejectionReason) => {
    switch (rejectionReason) {
      case 'staff_no_policy':
        return 'Not Listed on Policy'
      case 'policy_no_counselling':
        return 'Counselling Not Covered'
      case 'counselling_12_weeks':
        return 'Had Recent Counselling'
      case 'admin':
        return 'Cancelled by Admin'
      default:
        return 'N/A'
    }
  }

  const explanationText = (rejectionReason) => {
    switch (rejectionReason) {
      case 'staff_no_policy':
        return "Thank you for your enquiry, unfortunately, you aren't listed on your school policy, so we aren't able to proceed with a referral, please do speak with your business manager. Once you are added to the policy, we can continue with the referral. We are sorry for any inconvenience this may have caused you."
      case 'policy_no_counselling':
        return "Thank you for your enquiry, the service you've requested is not included within the cover school has purchased, please do contact nurse@uk.co.uk to see what is included in the cover."
      case 'counselling_12_weeks':
        return "Thank you for your request to access our services. We can see on our system; your last counselling session was within 12 weeks. Unfortunately, we won’t be able to refer you again at this time, as we have to allow a 12-week cooling period between referrals.\n\nIf you need any support in the meantime, please give our nurses a call on 01773 814403 or contact your own GP for assistance."
      case 'admin':
        return 'PLACEHOLDER'
      default:
        return 'N/A'
    }
  } 

  return (
    <section className="max-w-4xl mx-auto lg:p-6 text-portal-dark-blue">
      <div className="lg:px-4 py-6">
        <div className="flex items-start justify-between">
          <h2 className="text-xl lg:text-2xl font-semibold text-[#41264B]">
            Counselling Enquiry Information
          </h2>
        </div>
        <div className="flex-col justify-between space-y-10">
          <div className="bg-white border border-gray-200 rounded-lg overflow-hidden mt-5">
            <table className="w-full table-fixed text-sm">
              <tbody>
                <tr>
                  <td className="w-1/3 px-4 py-3 font-semibold">Status</td>
                  <td className="w-2/3 px-4 py-3">
                    <span
                      className={`${statusClass(
                        enquiry?.task_info?.counselling_info?.accepted
                      )} rounded-full px-3 py-1 text-xs font-semibold`}
                    >
                      {statusText(
                        enquiry?.task_info?.counselling_info?.accepted
                      ) || ''}
                    </span>
                  </td>
                </tr>

                <tr className="border-t">
                      <td className="w-1/3 px-4 py-3 font-semibold">Session Time Requested</td>
                      <td className="w-2/3 px-4 py-3">
                    {moment(enquiry?.task_info?.requested_time).format('dddd Do MMMM Y, h:mm A')}
                  </td>
                </tr>
                <tr className="border-t">
                      <td className="w-1/3 px-4 py-3 font-semibold">Time of Enquiry</td>
                      <td className="w-2/3 px-4 py-3">
                    {moment(enquiry?.created_at).format('dddd Do MMMM Y, h:mm A')}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {enquiry?.task_info?.counselling_info?.accepted === false && (
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
              <table className="w-full table-fixed text-sm">
                <tbody>
                  <tr>
                    <td className="w-1/5 px-4 py-3 font-semibold">More Information</td>
                    <td className="w-4/5 px-4 py-3 break-words whitespace-pre-line">
                      {explanationText(enquiry?.task_info?.counselling_info?.rejection_reason)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          <div className="flex gap-10">
            <button
              type="button"
              className="w-1/2 bg-gray-100 text-gray-700 border border-gray-300 rounded-md py-2 hover:bg-gray-200 transition mt-4"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
            {/* {enquiry?.task_info?.counselling_info?.accepted === undefined && (
              <button
                type="button"
                className="w-1/2 bg-red-500 text-white border border-red-600 rounded-md py-2 hover:bg-red-400 transition mt-4"
                onClick={() => console.log("HERE")}
              >
                Cancel Enquiry
              </button>
            )} */}
          </div>
        </div>
      </div>
    </section>
  )
}